import { ActivityTip } from './types';
import SectionHeader from './SectionHeader';
import TipItem from './TipItem';

interface ActivityTipsProps {
  tips: ActivityTip[];
}

/**
 * ActivityTips Component
 * 
 * "How to make play last longer" section with bulleted tips.
 * Responsive: Padding scales with container.
 */
export default function ActivityTips({ tips }: ActivityTipsProps) {
  return (
    <div style={{ marginTop: '24px' }}>
      <SectionHeader title="How to make play last longer" />
      
      <ul 
        className="flex flex-col gap-2 mt-6 mx-6 sm:mx-8 md:mx-10 lg:mx-12 pl-5"
        style={{
          listStyleType: 'disc',
        }}
      >
        {tips.map((tip) => (
          <TipItem key={tip.id} tip={tip} />
        ))}
      </ul>
    </div>
  );
}
